import React from 'react';

import styled from 'styled-components';

import { TeamSwitcher } from '@sine/sine-team-switcher';
import { FullScreenError, Heading, Text, spacing } from '@sine/sine-ui-components';

import { PageContainer } from '../../components/Page';

interface PermissionDeniedPageProps {
  currentTeamName?: string;
  teamCount: number;
}

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing(2)};

  margin-top: ${spacing(1)};
  padding: 0px ${spacing(12)};
  text-align: center;
`;

const TextContainer = styled.div`
  max-width: min(50vw, 750px);
`;

const TeamSwitcherDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  gap: ${spacing(1)};
`;

const TeamNameText = styled(Text)`
  font-weight: 500;
`;

export default function InsufficientPermissionsPage({ currentTeamName, teamCount }: PermissionDeniedPageProps) {
  const canSwitchTeams = teamCount > 1;

  let teamNameText;
  if (currentTeamName) {
    teamNameText = (
      <>
        {' '}
        for the team <TeamNameText>{currentTeamName}</TeamNameText>
      </>
    );
  }
  return (
    <PageContainer>
      <FullScreenError type='not_authorised' heading='Insufficient Permissions' />
      <InfoContainer>
        <TextContainer>
          <Text>
            You do not have permission to access this page {teamNameText}. Try switching to another team on which you
            are a Team Administrator or contact Sine Support for further assistance.
          </Text>
        </TextContainer>
        {canSwitchTeams && (
          <TeamSwitcherDiv>
            <Heading type={'h3'}>Try switching teams:</Heading>
            <TeamSwitcher />
          </TeamSwitcherDiv>
        )}
      </InfoContainer>
    </PageContainer>
  );
}
